/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { IdentifierKey } from 'cio/utils/identifiers';
import { task } from 'ember-concurrency';
import DS from 'ember-data';
import CustomerModel from 'cio/models/customer';
import CampaignModel from 'cio/models/campaign';
import SubjectModel, { STATE_LABELS } from 'cio/models/subject';
import { tracked } from '@glimmer/tracking';

interface JourneysTableArgs {
  campaign?: CampaignModel;
  customer?: CustomerModel;
  type?: string;
  continuation: string | null;
  updateMeta: (meta: { continuation: string }) => unknown;
}

export default class JourneysTable extends Component<JourneysTableArgs> {
  @service store!: DS.Store;

  @tracked subjects: SubjectModel[] = [];

  journeyStatusDefinitions = ['init', 'active', 'exited_early', 'inactive', 'finished'].map((state) => ({
    ...STATE_LABELS[state],
  }));

  get firstColumnType() {
    if (this.args.campaign != null) {
      if (this.args.campaign.isWebhookTriggered) {
        return 'webhook';
      }

      return 'person';
    }

    if (this.args.customer != null) {
      return 'campaign';
    }

    return null;
  }

  get fetchParams() {
    let params: Record<string, any> = {};

    if (this.args.campaign != null) {
      params.campaign_id = this.args.campaign.id;
    }

    if (this.args.customer != null && this.args.type != null) {
      params.type = this.args.type;
      params.internal_id = this.args.customer.identifiers[IdentifierKey.CioId];
    }

    return params;
  }

  fetchSubjects = task({ keepLatest: true }, async () => {
    let subjects = await this.store.query('subject', this.fetchParams);

    this.subjects = subjects.toArray();

    this.args.updateMeta((subjects as any).meta);
  });

  fetchMore = task({ drop: true }, async () => {
    let params = {
      ...this.fetchParams,
      continuation: this.args.continuation,
    };
    let subjects = await this.store.query('subject', params);

    this.subjects = [...this.subjects, ...subjects.toArray()];

    this.args.updateMeta((subjects as any).meta);
  });
}
